export default __webpack_public_path__ + "static/media/74.f43aa3c2.jpg";